module.exports = __webpack_public_path__ + "img/service3.f633ad6c.png";